import { FileUploadRequest } from "@/business/files/domain/files";
import { loadInvoiceUrl } from "@/business/files/infrastructure/constants/urls";
import { convertFormData } from "@/business/shared/commons/rest/convertToFormData";
import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const loadInvoiceService = {
  async execute(token: string, fileUploadRequest: FileUploadRequest): Promise<void> {
    const url = getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(loadInvoiceUrl);

    const formData = convertFormData(fileUploadRequest);

    const headers = {
      "web-token": token,
      Accept: "application/json",
    };

    const response: RestResponse = await restClient().sendRequest(
      url,
      "POST",
      formData,
      headers
    );

    if (!response.isSuccess) {
      const errorMessage =
        response.statusCode == 422
          ? DaccachErrorActions().extractFormError(response.content)
          : response.content;
      throw DaccachErrorActions().createError(errorMessage);
    }
  },
};